<!-- 报表条件配置列表 -->
<template>
	<div class="conditionConfig basis-page-cls" v-if="visible">
		<section class="basis-cls_table">
			<div class="header">
				<span class="title el-icon-document"> 条件配置列表</span>
				<div class="btns">
					<el-button size="small" @click="close">返回</el-button>
					<el-button type="primary" size="small" @click="showAddCondition()">新增</el-button>
				</div>
			</div>
			<div class="table">
				<table-pagination :data="list" :column="column" :total="total" :page.sync="queryInfo.pageNum" :limit.sync="queryInfo.pageSize" />
			</div>
		</section>
		<manageCondition ref="manageCondition" @requestList="requestList" />
		<optionList ref="optionList" />
	</div>
</template>
<script>
import manageCondition from "./components/manageCondition";
import optionList from './components/optionList';
export default {
	name: "conditionConfig",
	components: {
		manageCondition,
		optionList
	},
	data() {
		return {
			reportId: "",
			visible: false,
			list: [],
			queryInfo: {
				pageNum: 1,
				pageSize: 10,
				prantBrand: '',
				reportId: "",
				reportName: "",
				reportState: ""
			},
			total: 100,
			column: [{
					label: '创建时间',
					prop: 'createTime',
					minWidth: 120,
					render: (h, scope) => {
						return <span>{this.transformTime(scope.row.createTime)}</span>
					}
				},
				{ label: '创建人', prop: 'createBy', minWidth: 100 },
				{ label: '字段名称', prop: 'itemName', minWidth: 150 },
				{
					label: '字段显示类型',
					prop: 'showType',
					width: 150,
					render: (h, scope) => {
						return <span>{this.getShowType(scope.row.showType)}</span>
					}
				},
				{
					label: '字段访问类型',
					prop: 'accessType',
					width: 150,
					render: (h, scope) => {
						return <span>{this.getAccessTypeName(scope.row.accessType)}</span>
					}
				},
				{
					label: '必填',
					prop: 'isRequired',
					width: 80,
					render: (h, scope) => {
						return (
							<span>{scope.row.isRequired == "1"?'是':"否"}</span>
						)
					}
				},
				{
					label: '可选项配置',
					prop: 'reportType',
					width: 120,
					render: (h, scope) => {
						return (scope.row.showType == "select" || scope.row.showType == "multipleSelect") && <el-button type="text" onClick={()=>this.openOptionList(scope.row)}>可选项配置</el-button>
					}
				},
				{
					label: '操作',
					minWidth: 180,
					render: (h, scope) => {
						return (
							<div>
								<el-button type="text" onClick={()=>this.showConditionDetail(scope.row)}>详情</el-button>
								<el-button type="text" onClick={()=>this.updateCondition(scope.row)}>修改</el-button>
								<el-button type="text" onClick={()=>this.deleteCondition(scope.row)}>删除</el-button>
							</div>
						)
					}
				},
			],
			//
		}
	},
	methods: {
		initTable(itemList) {
			let list = [];
			for (let item of itemList) {
				list.push(item.item);
			}
			this.list = list;
		},
		requestList() {
			this.$api.reportExtractParamsAction({
				reportId: this.reportId
			}).then(rs => {
				if (!rs) return false;
				let { data } = rs;
				this.initTable(data.itemList);
				console.log(data);
			})
		},
		open(reportData) {
			this.reportId = reportData.reportId;
			this.visible = true;
			this.requestList();
		},
		close() {
			this.list = null;
			this.visible = false;
		},

		showAddCondition() {
			this.$refs.manageCondition.addReport();
		},
		updateCondition(conditionData) {
			this.$refs.manageCondition.updateCondition(conditionData);
		},
		showConditionDetail(conditionData) {
			this.$refs.manageCondition.conditionDetail(conditionData);
		},
		deleteCondition(conditionData) {
			this.$confirm(`是否要删除条件配置"${conditionData.itemName}"`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.reportDefinitionItemDeleteJson(conditionData)
					.then((res) => {
						this.$message({
							type: 'success',
							message: '操作成功!'
						})
						this.requestList();
					})
			})
		},
		openOptionList(conditionData) {
			this.$refs.optionList.open(conditionData);
		},
		getShowType(code) {
			switch (code) {
				case "text":
					return "文本";
				case "month":
					return "月份";
				case "date":
					return "日期";
				case "datetime":
					return "时间";
				case "select":
					return "下拉框";
				case "multipleSelect":
					return "多选下拉框";
				default:
					return "未知项";
			}
		},
		getAccessTypeName(code) {
			switch (code) {
				case "hidden":
					return "隐藏";
				case "read":
					return "只读";
				case "write":
					return "读写";
				default:
					return "";
			}
		},
		transformTime(timeString){
			let date = new Date(timeString);
			return date.toLocaleString("ch-CN",{hour12: false})
		}
	},
}
</script>
<style scoped>
.conditionConfig {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background: white;
	z-index: 1;
}
</style>